import styled from 'styled-components';

export { Button } from '../semcore';

export const IconButton = styled.button`
    background: none;
    border: none;
`;
